import React, { FC, useCallback, useState } from 'react'
import { Button } from '@wmgtech/legato'
import { cn } from 'shared/utils'

import { IFollowButtonProps } from './FollowButton.props'

import './FollowButton.scss'

const FollowButton: FC<IFollowButtonProps> = ({
  className,
  isFollowed,
  unfollowProject,
  followProject,
  dataTestPrefix,
  disabled
}) => {
  const [hovered, setHovered] = useState<Boolean>(false)

  const clickHandler = useCallback(
    (e) => {
      e.stopPropagation()
      e.preventDefault()

      isFollowed ? unfollowProject() : followProject()
    },
    [isFollowed, unfollowProject, followProject]
  )
  const mouseEnter = () => setHovered(true)
  const mouseLeave = () => setHovered(false)

  const getLabel = (isFollowed: boolean) => {
    if (isFollowed && hovered) {
      return 'Unfollow'
    }
    if (isFollowed) {
      return 'Following'
    }
    return 'Follow'
  }

  return (
    <Button
      data-edit-mode
      className={cn('follow-button', className, { 'is-followed': isFollowed })}
      containerStyle={isFollowed && !disabled ? 'link' : 'solid'}
      colorType="secondary-black"
      label={getLabel(isFollowed)}
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
      disabled={disabled}
      size="sm"
      onClick={clickHandler}
      data-test={`${dataTestPrefix}_follow_btn`}
    />
  )
}

export default FollowButton
